var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTotalattendence(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.402,
    height: 31.326,
    viewBox: "0 0 41.402 41.326",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user_1_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1236",
    "data-name": "Path 1236",
    d: "M19.391-511.636c-.129.016-.525.073-.88.121a12.274,12.274,0,0,0-5.985,2.819A12.281,12.281,0,0,0,8.6-501.629a16.05,16.05,0,0,0,.04,4.038,12.238,12.238,0,0,0,4.442,7.293l.549.42-.226.081a20.718,20.718,0,0,0-2.229.969,20.769,20.769,0,0,0-8.578,8A20.514,20.514,0,0,0-.243-471.3l-.057.969H2.955v-.4a18.292,18.292,0,0,1,2.665-8.844,17.492,17.492,0,0,1,9.337-7.31,16.976,16.976,0,0,1,10.888,0,17.492,17.492,0,0,1,9.337,7.31,18.292,18.292,0,0,1,2.665,8.844v.4H41.1l-.057-.969a20.514,20.514,0,0,0-2.843-9.531,20.769,20.769,0,0,0-8.578-8A20.719,20.719,0,0,0,27.4-489.8l-.226-.081.549-.42a12.238,12.238,0,0,0,4.442-7.293,16.05,16.05,0,0,0,.04-4.038,12.561,12.561,0,0,0-2.843-5.993,12.218,12.218,0,0,0-6.849-3.869A19.213,19.213,0,0,0,19.391-511.636Zm2.375,3.3A8.736,8.736,0,0,1,29-498.366a8.736,8.736,0,0,1-9.967,7.237A8.736,8.736,0,0,1,11.8-501.1,8.736,8.736,0,0,1,21.766-508.333Z",
    transform: "translate(0.3 511.657)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalattendence);
export default __webpack_public_path__ + "static/media/TOTAL ATTENDENCE.57c7ae00f213e34392e10bbc9fdd6b78.svg";
export { ForwardRef as ReactComponent };